import { Navbar } from 'ionic-angular/components/toolbar/navbar';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';

@Component({
  selector: 'page-publication',
  templateUrl: 'publication.html',
  providers : [HttpClient, CustomToast]
})
export class PublicationPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  publication = {
    id : -1,
    name : '',
    date : '',
    url : '',
    vol_pag : '',
    authors : '',
    journal : ''
  };

  customToast : CustomToast;
  events : Events;
  alertCtrl : AlertController;

  @ViewChild(Navbar) navBar : Navbar;


  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events, alertCtrl : AlertController) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.alertCtrl = alertCtrl;
    let id = this.navParams.get('id');
    this.httpCallPublication(id);
  }
  
  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertCtrl.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }

  httpCallPublication(id){
    this.httpClient.get('/publications/'+id,(error,data)=>{
      if(!error){
        this.publication = data.json();
      }
    });
  }

  httpUpdatePublication(){
    this.publication.date = this.publication.date.split('T')[0];
    this.httpClient.put('/publications',this.publication,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Publicación actualizada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('publication:update');
      }
    });
  }

  onClickSave(){
    this.httpUpdatePublication();
  }

  onClickDelete(){
    let alert = this.alertCtrl.create({
      title : '¿Estas seguro?',message : 'Vas a eliminar la información de esta publicación',
      buttons:[{
        text : 'No',
        role : 'cancel'
        },
        {
        text : 'Si',
        role : 'confirm',
          handler : ()=>{
            this.httpCallDelete();
          }
        }
      ]
    });
    alert.present();
  }

  httpCallDelete(){
    this.httpClient.delete('/publications/'+this.publication.id,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Publicación eliminada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('publication:delete');
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/publications/publication/publication.ts